import { render } from "./Medico.vue?vue&type=template&id=74ee9187&scoped=true"
import script from "./Medico.vue?vue&type=script&lang=js"
export * from "./Medico.vue?vue&type=script&lang=js"

import "./Medico.vue?vue&type=style&index=0&id=74ee9187&scoped=true&lang=css"

import exportComponent from "/mnt/gasoil_files/gasoil/docker/gasoil/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74ee9187"]])

export default __exports__